// Some JP apps handle checkout clicks without native form validation.
// Capture before their delegated handlers; look up the current checkbox after
// each cart section render rather than retaining a detached control.
const cartFormIds = ['jp-cart-page-form', 'cart-form'];

function guardCheckout(event) {
  const target = event.target;
  const checkout = event.type === 'click'
    ? target?.closest?.('[name="checkout"]')
    : event.submitter;
  const expectedFormId = checkout?.getAttribute?.('form') || checkout?.form?.id || target?.id;
  const isCheckout = event.type === 'click'
    ? cartFormIds.includes(expectedFormId) || checkout?.dataset?.jpTermsRequired === 'true'
    : cartFormIds.includes(target?.id) && (!checkout || checkout.name === 'checkout');
  if (!isCheckout) return;

  const formId = expectedFormId;
  const form = checkout?.form || target;
  const terms = document.getElementById(formId === 'cart-form' ? 'jp-cart-drawer-terms' : 'jp-cart-terms');
  const required = form?.dataset?.jpTermsRequired === 'true' || checkout?.dataset?.jpTermsRequired === 'true' || terms?.required;
  const associated = terms?.required && terms.form === form && form?.id === formId;
  const button = checkout || document.querySelector(`[name="checkout"][form="${formId}"]`);
  const container = button?.closest?.('.cart__ctas');
  if (associated || !required) container?.querySelector('[data-jp-terms-error]')?.remove();
  if (!required || (associated && terms.checked)) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  if (associated) {
    terms.focus();
    terms.reportValidity();
    return;
  }
  // A required control can temporarily disappear during an app/section update.
  // Keep checkout closed and give the customer a visible recovery instruction.
  if (container) {
    let message = container.querySelector('[data-jp-terms-error]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.jpTermsError = '';
      message.setAttribute('role', 'alert');
      container.append(message);
    }
    message.textContent = '利用規約の確認欄を読み込めませんでした。ページを再読み込みして、もう一度お試しください。';
  }
  button?.focus?.();
}

window.addEventListener('click', guardCheckout, { capture: true });
window.addEventListener('submit', guardCheckout, { capture: true });
